//
//
//
//

export default {
  name: "AppResultCount",
  props: ["results", "currentResultsStart", "currentResultsEnd"],
  data() {
    return {};
  },
  computed: {
		label() {
			if (this.$root.config.resultsLabelTemplate) {
				return this.$root.config.resultsLabelTemplate.replace("{start}", this.currentResultsStart).replace("{end}", this.currentResultsEnd).replace("{total}", this.results.totalResultCount);
			} else {
				// Fallback to default bluesearch result count label format
				return `Showing ${this.currentResultsStart}-${this.currentResultsEnd} of ${this.results.length > 1 ? "results" : "result"}.`;
			}
		},
	},
};
